
import { Link } from 'react-router-dom';

const AdvantageSection = () => {
  return (
    <section className="py-32 bg-gradient-to-b from-slate-800/30 to-slate-900/30 relative overflow-hidden">
      {/* 精致背景装饰 */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-600/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-cyan-600/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative container mx-auto px-8">
        <div className="text-center mb-20">
          <div className="inline-block mb-6">
            <span className="px-4 py-2 bg-blue-600/20 text-blue-300 rounded-full text-sm font-medium border border-blue-400/30">
              Strategic Location
            </span>
          </div>
          <h2 className="text-5xl md:text-6xl font-light text-white mb-8 leading-tight">
            Hong Kong: Our <strong className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">Strategic Advantage</strong>
          </h2>
          <p className="text-xl text-white/80 max-w-4xl mx-auto font-light leading-relaxed">
            Leveraging Hong Kong's unique position as a global financial and technology hub to deliver unparalleled value
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-7xl mx-auto mb-20">
          <div className="group relative">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 to-cyan-600/10 rounded-3xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
            <div className="relative bg-white/8 backdrop-blur-md border border-white/20 rounded-3xl p-8 hover:bg-white/12 hover:border-blue-400/40 transition-all duration-500 hover:transform hover:scale-105 h-full">
              <div className="w-20 h-20 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 rounded-3xl flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-300 border border-blue-400/30">
                <i className="ri-global-line text-3xl text-blue-400"></i>
              </div>
              <h3 className="text-2xl font-semibold text-white mb-6 group-hover:text-blue-100 transition-colors duration-300">International Connectivity</h3>
              <p className="text-white/80 leading-relaxed font-light text-lg">
                Hong Kong's strategic location provides unparalleled access to both Eastern and Western markets, enabling seamless technology transfer and business development across continents.
              </p>
            </div>
          </div>

          <div className="group relative">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 to-cyan-600/10 rounded-3xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
            <div className="relative bg-white/8 backdrop-blur-md border border-white/20 rounded-3xl p-8 hover:bg-white/12 hover:border-blue-400/40 transition-all duration-500 hover:transform hover:scale-105 h-full">
              <div className="w-20 h-20 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 rounded-3xl flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-300 border border-blue-400/30">
                <i className="ri-shield-check-line text-3xl text-blue-400"></i>
              </div>
              <h3 className="text-2xl font-semibold text-white mb-6 group-hover:text-blue-100 transition-colors duration-300">Robust IP Protection</h3>
              <p className="text-white/80 leading-relaxed font-light text-lg">
                World-class intellectual property protection framework ensures secure technology transfer and innovation development, providing confidence for international partnerships.
              </p>
            </div>
          </div>

          <div className="group relative">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 to-cyan-600/10 rounded-3xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
            <div className="relative bg-white/8 backdrop-blur-md border border-white/20 rounded-3xl p-8 hover:bg-white/12 hover:border-blue-400/40 transition-all duration-500 hover:transform hover:scale-105 h-full">
              <div className="w-20 h-20 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 rounded-3xl flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-300 border border-blue-400/30">
                <i className="ri-team-line text-3xl text-blue-400"></i>
              </div>
              <h3 className="text-2xl font-semibold text-white mb-6 group-hover:text-blue-100 transition-colors duration-300">World-Class Talent</h3>
              <p className="text-white/80 leading-relaxed font-light text-lg">
                Access to diverse, highly skilled professionals from leading universities and international corporations, driving innovation and excellence in every project.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center">
          <div className="relative group max-w-5xl mx-auto">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 to-cyan-600/10 rounded-3xl blur-2xl group-hover:blur-3xl transition-all duration-500"></div>
            <div className="relative bg-gradient-to-r from-blue-900/20 via-slate-900/20 to-blue-900/20 backdrop-blur-md border border-blue-400/30 rounded-3xl p-12 hover:border-blue-400/50 transition-all duration-500">
              <h3 className="text-3xl md:text-4xl font-light text-white mb-6 leading-tight">
                Ready to Leverage Our <strong className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">Hong Kong Advantage</strong>?
              </h3>
              <p className="text-white/80 mb-8 max-w-3xl mx-auto text-lg font-light leading-relaxed">
                Discover how our strategic location and local expertise can accelerate your technology initiatives and market expansion through innovative partnerships.
              </p>
              <Link 
                to="/contact" 
                className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white rounded-xl transition-all duration-300 font-medium whitespace-nowrap cursor-pointer shadow-lg shadow-blue-600/25 group/btn"
              >
                <span>Start Your Journey</span>
                <i className="ri-arrow-right-line ml-2 group-hover/btn:translate-x-1 transition-transform duration-300"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvantageSection;
